import { FieldTypes } from '../../constants/FieldTypes'
import { FieldMap, ListField } from '../../types/forms/fields'
import { getBooleanHistoryField } from '../shared'

const injuriesListField: ListField = {
  name: 'Injuries',
  itemFields: {
    type: FieldTypes.TEXTAREA,
    placeholder: 'Injury details',
  },
  itemName: 'Injury',
  condition: v => !!v?.injuries,
}

const surgeriesListField: ListField = {
  name: 'Surgeries',
  itemFields: {
    type: FieldTypes.TEXTAREA,
    placeholder: 'Surgery details',
  },
  itemName: 'Surgery',
  condition: v => !!v?.surgeries,
}

export const injuriesAndSurgeriesField: FieldMap = {
  name: 'Injuries and Surgeries',
  children: {
    injuries: getBooleanHistoryField('Injuries'),
    injuriesList: injuriesListField,
    surgeries: getBooleanHistoryField('Surgeries'),
    surgeriesList: surgeriesListField,
  },
}
